import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface ForgotPasswordRequest {
  email: string
}

const requestPasswordReset = async ({
  email,
}: ForgotPasswordRequest): Promise<void> => {
  await api.post('/authentication/forgot-password', { email })
}

export const useForgotPassword = () => {
  return useMutation<void, Error, ForgotPasswordRequest>({
    mutationFn: requestPasswordReset,
  })
}
